import React from 'react';
import Imgix from 'react-imgix';
import Shadow from '../Shadow';
import { endSlash } from '../../util/helperFunctions';

// This banner is used on the ListGrid template for minor categories
// eslint-disable-next-line react/prop-types
const ListGridBannerMinor = ({ page, titleWidth = '530', abstractPhotoForMobile = false }) => (
  <div className="banner--list-grid banner--list-grid--minor bg-blue relative flex flex-column items-center justify-center-l items-start-l">
    {page.bannerImage && (
      <div className={`absolute top-0 left-0 h-100 w-100 ${abstractPhotoForMobile ? 'large-screen-up' : ''}`}>
        <Imgix
          src={endSlash(page.bannerImage.url)}
          className="bg-center image-cover mb0 h-100 w-100"
          imgixParams={{
            'max-w': 2732,
            'max-h': 600,
            'fp-x': page.bannerImageFocalPointX,
            'fp-y': page.bannerImageFocalPointY,
            auto: ['compress'],
            fit: 'crop',
            crop: 'focalpoint'
          }}
          htmlAttributes={{
            alt: page.bannerImageAltText
          }}
        />
      </div>
    )}
    {page.abstractPhoto && abstractPhotoForMobile && (
      <div className="absolute top-0 left-0 h-100 w-100 not-large-screen-only">
        <Imgix
          src={endSlash(page.abstractPhoto.url)}
          className="bg-center image-cover mb0 h-100 w-100"
          imgixParams={{
            'max-w': 2732,
            'max-h': 600,
            'fp-x': page.abstractPhotoFocalPointX,
            'fp-y': page.abstractPhotoFocalPointy,
            auto: ['compress'],
            fit: 'crop',
            crop: 'focalpoint'
          }}
          htmlAttributes={{
            alt: page.abstractPhotoAltText
          }}
        />
      </div>
    )}
    <h1 className={`mw-${titleWidth} white tc tl-l h-2 h-1--l mb2`}>
      {page.title}
    </h1>
    <h2 className="mw-530 white ttu tc tl-l h-5 mb0">
      {page.subtitle}
    </h2>
  </div>
);

export default ListGridBannerMinor;



// WEBPACK FOOTER //
// ./src/components/Banners/ListGridBannerMinor.js